<template>
  <div class="sticky">
    <div class="itemsheader">
      <div class="item opdrlistopdrachtnummer" style="opacity: 1;min-width: 160px;max-width:200px;">
        <span class="tekst">Opdrachtnummer</span>
      </div>
      <div class="item opdrlistbedrijfsnaam" style="min-width:200px;">
        <span class="tekst">Bedrijfsnaam</span>
      </div>
      <div class="item opdrlistdisciplines" style="min-width:200px;">
        <span class="tekst">Discipline</span>
      </div>
      <div class="item opdrliststatus" style="opacity: 1;min-width:220px;">
        <span class="tekst">Status</span>
      </div>
      <div class="item opdrlisttekenaar" style="opacity: 1;min-width:220px;">
        <span class="tekst">Tekenaar</span>
      </div>
    </div>

    <div class="filterbar" v-if="showOpdrFilters">
      <div class="item opdrlistopdrachtnummer" style="opacity: 1;min-width: 160px;max-width:200px;">
        <SearchfieldWithReset :filterOn="opdrFilters.opdrachtnummer" filterBy="opdrachtnummer" />
      </div>
      <div class="item opdrlistbedrijfsnaam" style="min-width:200px; width:23%;">
        <SearchfieldWithReset :filterOn="opdrFilters.bedrijfsnaam" filterBy="bedrijfsnaam" />
      </div>
      <div class="item opdrlistdisciplines" style="min-width:200px; width:22%;">
        <DropdownSelect2
          :class="{
            pastel0: opdrFilters.disciplines == '',
            pastel1: opdrFilters.disciplines == 'Bouwkunde',
            pastel2: opdrFilters.disciplines == 'Werktuigbouwkunde',
            pastel3: opdrFilters.disciplines == 'Installatietechniek',
            pastel4: opdrFilters.disciplines == 'Elektrotechniek',
            pastel5: opdrFilters.disciplines == 'Huisvesting',
            pastel6: opdrFilters.disciplines == 'Plattegronden',
            pastel7: opdrFilters.disciplines == 'Concepten - 3D Print',
            pastel8: opdrFilters.disciplines == 'Brandpreventie',
            pastel9: opdrFilters.disciplines == 'Nen2580'
          }"
          :filterOn="opdrFilters.disciplines"
          filterBy="disciplines"
        />
      </div>
      <div class="item opdrliststatus" style="opacity: 1;min-width:220px;">
        <SearchfieldWithReset :filterOn="opdrFilters.status" filterBy="status" />
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store';
import SearchfieldWithReset from './SearchfieldWithReset';
import DropdownSelect2 from './DropdownSelect2';

export default {
  name: 'ItemsHeader',
  components: {
    SearchfieldWithReset,
    DropdownSelect2
  },
  computed: {
    showOpdrFilters() {
      return store.state.showOpdrFilters;
    },
    opdrFilters() {
      return store.state.opdrFilters;
    }
  }
};
</script>

<style scoped>
/* .sticky {
  position: sticky;
  top: 100px;
  z-index: 1;
} */
.itemsheader {
  /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
  padding: 25px 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  border: 1px solid #c5d8e3;
}

.filterbar {
  padding: 0px 25px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  margin-top: -1px;
  border-top: 1px solid #e4ecfa;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}

.item {
  opacity: 1;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  width: 25%;
}

.tekst {
  white-space: nowrap;
  color: #0b1125;
}
.pastel0 {
  background-color: #bbb;
}
</style>
